import React from 'react';
import Header from './Header';

const Contact = () => {
    return (
        <div>
            <Header />
            <h2>Contact Us</h2>
            <p>Have questions, feedback, or need support? We’d love to hear from you!</p>
            <p>You can reach out to us anytime through the following contact options. Our team is here to assist you</p>
            <p>with your queries, technical issues, or partnership opportunities.</p>
            <h3>Contact Information:</h3>
            <ul>
                <li>Email: support@studyapp.com</li>
                <li>Phone: +1 (123) 456-7890</li>
                <li>Address: 123 Learning Lane, Education City, ED 45678</li>
                <li>Office Hours: Monday to Friday, 9:00 AM - 6:00 PM</li>
                <li>Website: www.studyapp.com</li>
            </ul>
            <p>We look forward to connecting with you and helping you on your learning journey!</p>
        </div>

    );
};

export default Contact;
